import {createContext} from 'react';
import {OAuthManager} from './oauth';

export const OAuthManagerContext = createContext<OAuthManager | null>(null);
